import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  private auditInformation = new BehaviorSubject<string>('');
  public auditInformation$ = this.auditInformation.asObservable();

  storeInformation(value: string) {
    this.auditInformation.next(value);
  }

}
